import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate } from './shared/common'
// controllers
import Controller from './controllers/Controller'
import ObjectController from './controllers/ObjectController'
import ObjectImageController from './controllers/ObjectImageController'
import ObjectDocumentController from './controllers/ObjectDocumentController'
import ObjectVideoController from './controllers/ObjectVideoController'
import CollectionObjectsController from './controllers/CollectionObjectsController'
import TimelineController from './controllers/TimelineController'
import RowlCarouselController from './controllers/RowlCarouselController'
import HomeAboutController from './controllers/HomeAboutController'
import RRollController from './controllers/RRollController'
// views
// import BasicView from './views/BasicView'
import { initDropdownFix } from './shared/dropdown-fix'
import { initFormValidation } from './shared/form-validation'


const routes = {
  'webflow': {
    controller: Controller,
    view: RytmWebflow.WebflowView
  },
  'list': {
    controller: Controller,
    view: RytmWebflow.WebflowListView
  },
  "object": {
    controller: ObjectController
  },
  "object_image": {
    controller: ObjectImageController
  },
  "object_document": {
    controller: ObjectDocumentController
  },
  "object_video": {
    controller: ObjectVideoController
  },
  "collection_objects": {
    controller: CollectionObjectsController
  },
  "timeline": {
    controller: TimelineController,
    view: RytmWebflow.WebflowView
  },
  "rowl": {
    controller: RowlCarouselController
  },
  "home_about": {
    controller: HomeAboutController
  },
  "r_roll": {
    controller: RRollController
  },
}

const aswapProps = {
  animationTimeHide: 500,
  animationTimeShow: 600,
  preloadOnHover: false,
  cacheOn: false,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    WCAG.onViewChanged();
    windowUpdate();
    initDropdownFix();
    initFormValidation();
    RytmWebflow.showUp.rebuild();
  },
  onViewShown: () => {
    // console.log("#### SHOWN");
    setTimeout(() => {
      if (RytmWebflow.scrollController) {
        RytmWebflow.scrollController.refresh();
      }
    }, 1000)
  },
  onViewHide: () => {
    WCAG.dialogCloseAll();
    // RytmWebflow.showUp.hide()
    RytmWebflow.bootsrap5.hideFlyovers();
  },
  onViewHidden: () => {
  },
  onRequestSameUrl: () => {
    // same url request
    RytmWebflow.bootsrap5.hideFlyovers();
  },
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}